<template>
  <div class="follow_up mt-3">
    <v-card class="custom_card" background="#fff">
      {{ this.filter.region_id }}
      <v-layout>
        <!-- ร้อยละผลติดตาม -->
        <v-flex xs2 class="pr-6" style="border-right: 1px solid #d3d3d3">
          <div class="font-20 font-w-700">ร้อยละผลติดตาม</div>
          <div class="font-16">ตามแผนงาน</div>

          <v-card
            flat
            v-for="(plan, i) in data.plans"
            :key="i"
            class="mb-6 mt-6"
          >
            <div
              class="font-32 font-w-700 font-pp"
              :style="{ color: plan.code }"
            >
              {{ checkFormatNummber(plan.rate) }}<span class="font-24">%</span>
            </div>
            <div class="font-14 font-w-700 mt-n2">
              <div>{{ plan.nameTH }}</div>
              <div>{{ plan.nameEN }}</div>
            </div>
          </v-card>
        </v-flex>

        <!-- ภาพรวมผลติดตาม -->
        <v-flex xs5 class="px-5" style="border-right: 1px solid #d3d3d3">
          <!-- ตามภูมิภาค -->
          <div class="font-20 font-w-700">ภาพรวมผลติดตาม</div>
          <div class="font-16">ตามภูมิภาค</div>
          <div flat v-for="(region, i) in data.regions" :key="i" class="mt-6">
            <div class="font-10 font-w-700 mb-2">
              <div>{{ region.name }}</div>
            </div>
            <v-layout align-center>
              <v-flex>
                <v-progress-linear
                  rounded
                  height="15"
                  :color="region.code"
                  background-color="#efefefef"
                  :value="region.rate"
                ></v-progress-linear>
              </v-flex>
              <v-flex
                shrink
                class="font-12 font-w-700 pl-5"
                :style="{ color: region.code }"
              >
                {{ checkFormatNummber(region.rate) }}%
              </v-flex>
            </v-layout>
          </div>

          <v-divider class="mt-6 mb-4" />

          <!-- ทั้งหมด -->
          <v-layout justify-space-between>
            <v-flex shrink>
              <div class="font-24 font-w-700">ภาพรวมผลติดตาม</div>
              <div class="font-16 font-w-400">ทั้งหมด</div>
            </v-flex>
            <v-spacer />
            <v-flex shrink class="font-36 font-w-700 font-pp pr-6">
              {{ data.allProgressRate }}<span class="font-24">%</span>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex shrink class="gauge_chart">
              <highcharts
                v-if="isGaugeChartOptions"
                :options="gaugeChartOptions"
              ></highcharts>
              <v-layout
                justify-space-between
                mt-n6
                pr-10
                pl-12
                style="position: relative; z-index: 99"
              >
                <v-flex shrink>0%</v-flex>
                <v-flex shrink>100%</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- จำนวนโครงการ -->
        <v-flex xs5 class="pl-6">
          <v-layout justify-space-between>
            <v-flex shrink>
              <div class="font-24 font-w-700">จำนวนโครงการ</div>
              <div class="font-16 font-w-400">ตามงบประมาณ</div>
            </v-flex>
            <v-spacer />
            <v-flex shrink>
              <v-btn icon @click="showDialog()">
                <Icon
                  style="color: #b1b1b1"
                  class="font-32"
                  icon="ant-design:fullscreen-outlined"
                />
              </v-btn>
            </v-flex>
          </v-layout>
          <div v-show="mapSelected === true">
            <highcharts
              :constructor-type="'mapChart'"
              :options="mapOptions"
              class="map"
              style="margin-bottom: -17px; margin-left: -12px"
            ></highcharts>
          </div>

          <div v-show="mapSelected === false">
            <highcharts
              :constructor-type="'mapChart'"
              :options="mapRegionOptions"
              class="map"
            ></highcharts>
          </div>

          <v-layout justify-space-between align-end>
            <!-- <v-flex shrink v-if="mapSelected">
              <v-card width="120" flat color="#F5F5F5" class="px-2">
                <v-layout align-center>
                  <v-flex shrink pr-1>
                    <Icon
                      style="color: #f7941d"
                      class="font-10"
                      icon="material-symbols:circle"
                    />
                  </v-flex>
                  <v-flex shrink class="font-10 font-w-700">
                    0 - 5 ล้าน (8)
                  </v-flex>
                </v-layout>
                <v-layout align-center>
                  <v-flex shrink pr-1>
                    <Icon
                      style="color: #f15a29"
                      class="font-10"
                      icon="material-symbols:circle"
                    />
                  </v-flex>
                  <v-flex shrink class="font-10 font-w-700">
                    5.1 ล้าน - 10 ล้าน (3)
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex> -->
            <v-flex
              v-if="!mapSelected"
              shrink
              pl-1
              style="
                background-color: #f5f5f5;
                border-radius: 5px;
                width: 265px;
              "
            >
              <v-layout wrap justify-start>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #f9bb43"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคเหนือ
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #ee8046"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันออกเฉียงเหนือ
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #ff6161"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันตก
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #3b608a"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700"> ภาคใต้ </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #216957"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันออกเฉียงเหนือตอนล่าง
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #41dfff"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700"> ภาคกลาง </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #c198c4"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันออก
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink pl-1>
              <div
                class="btn_switch_map"
                :style="mapSelected ? { 'margin-top': '-30px !important' } : {}"
                @click="mapSelected = !mapSelected"
              >
                <v-layout align-center justify-space-between>
                  <v-flex shrink>
                    <Icon
                      style="color: #fff"
                      class="font-18 pt-1"
                      icon="material-symbols:candlestick-chart-rounded"
                    />
                  </v-flex>
                  <v-flex shrink class="font-12 font-w-700">
                    {{ mapSelected ? "จังหวัด" : "ภูมิภาค" }}
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- การใช้งบประมาณของแต่ละโครงการ -->
    <div class="mt-6">
      <div class="font-20 font-w-700">การใช้งบประมาณของแต่ละโครงการ</div>
      <v-card class="custom_card mt-3" background="#fff">
        <v-simple-table class="custom_table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">ลำดับ</th>
                <th class="text-left">แผนงาน</th>
                <th class="text-left">ชื่อโครงการ</th>
                <th class="text-left">มหาวิทยาลัย</th>
                <th class="text-left">จังหวัด</th>
                <th class="text-left">ระยะเวลาโครงการ</th>
                <th class="text-left">งบประมาณ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data.budgetProjects" :key="i">
                <td width="3%" class="text-center">{{ no(i + 1) }}</td>
                <td width="17%">
                  <div class="ellipsis-1-line">
                    {{ item.planMaster }}
                  </div>
                </td>
                <td width="23%">
                  <div class="ellipsis-1-line">
                    {{ item.projectName }}
                  </div>
                </td>
                <td width="13%">
                  <div class="ellipsis-1-line">
                    {{ item.university }}
                  </div>
                </td>
                <td width="10%">
                  <div class="ellipsis-1-line">
                    {{ item.province }}
                  </div>
                </td>
                <td width="20%">
                  <v-progress-linear
                    rounded
                    height="25"
                    color="#3B608A"
                    background-color="#B1B1B1"
                    :value="item.progressRate"
                  >
                    <div style="color: #fff" class="font-12">
                      {{ item.projectStart }} -
                      {{ item.projectEnd }}
                    </div>
                  </v-progress-linear>
                </td>
                <td width="15%">
                  <v-layout align-center>
                    <v-flex xs3>
                      <v-progress-linear
                        rounded
                        height="8"
                        color="#EE8046"
                        background-color="#B1B1B1"
                        :value="item.usageBudget"
                      >
                      </v-progress-linear>
                    </v-flex>
                    <v-flex
                      class="pl-2 font-12 font-w-700"
                      xs9
                      :style="{ color: '#EE8046' }"
                    >
                      {{ checkFormatNummber(item.totalBudget) }}฿
                    </v-flex>
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <!-- Paginate -->
      <v-layout
        mt-4
        justify-end
        class="custom_paginate"
        v-if="data.budgetProjects.length > 10"
      >
        <v-flex shrink>
          <v-pagination
            v-model="paginate.current_page"
            :length="paginate.last_page"
            color="#DE7033"
            @input="onPageChange"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog
      v-model="dialog"
      color="#fff"
      width="800"
      persistent
      style="height: 100%"
    >
      <div class="pa-4" style="position: relative; background-color: #fff">
        <div class="font-20 font-w-700 font-ch">
          {{
            mapSelected ? "จังหวัดและจำนวนโครงการ" : "ภูมิภาคและจำนวนโครงการ"
          }}
        </div>
        <div class="font-16 font-w-400">ตามงบประมาณ</div>
        <v-btn
          icon
          absolute
          top
          right
          style="z-index: 99"
          @click="closeDialog()"
        >
          <Icon
            class="font-32"
            style="color: #b1b1b1"
            icon="ant-design:fullscreen-exit-outlined"
          />
        </v-btn>
        <div v-show="mapSelected === true">
          <highcharts
            :constructor-type="'mapChart'"
            :options="mapOptions"
            class="map"
            style="margin-bottom: -17px"
          ></highcharts>
        </div>

        <div v-show="mapSelected === false" class="pl-3">
          <highcharts
            :constructor-type="'mapChart'"
            :options="mapRegionOptions"
            class="map"
          ></highcharts>

          <v-layout justify-space-between align-end>
            <v-flex
              shrink
              pl-1
              style="
                background-color: #f5f5f5;
                border-radius: 5px;
                width: 265px;
              "
            >
              <v-layout wrap justify-start>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #f9bb43"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคเหนือ
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #ee8046"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันออกเฉียงเหนือ
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #ff6161"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันตก
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #3b608a"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700"> ภาคใต้ </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #216957"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันออกเฉียงเหนือตอนล่าง
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #41dfff"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700"> ภาคกลาง </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink pr-2>
                  <v-layout align-center>
                    <v-flex shrink pr-1>
                      <Icon
                        style="color: #c198c4"
                        class="font-10"
                        icon="material-symbols:circle"
                      />
                    </v-flex>
                    <v-flex shrink class="font-10 font-w-700">
                      ภาคตะวันออก
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer />
          </v-layout>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { Icon } from "@iconify/vue2";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import mapInit from "highcharts/modules/map";
import moment from "moment";
import ThailandMapData from "./th-all.topo.json";
import { reLogin } from "../../main";

mapInit(Highcharts);
const items = [
  ["th-ct", 0, 0], // จันทบุรี
  ["th-4255", 0, 0], // Thailand
  ["th-pg", 0, 0], // พังงา
  ["th-st", 0, 0], // สุราษฎร์ธานี
  ["th-kr", 0, 0], // กระบี่
  ["th-sa", 0, 0], // สตูล
  ["th-tg", 0, 0], // ตรัง
  ["th-tt", 0, 0], // ตราด
  ["th-pl", 0, 0], // พัทลุง
  ["th-ps", 0, 0], // พิษณุโลก
  ["th-kp", 0, 0], // กำแพงเพชร
  ["th-pc", 0, 0], // พิจิตร
  ["th-sh", 0, 0], // สุพรรณบุรี
  ["th-at", 0, 0], // อ่างทอง
  ["th-lb", 0, 0], // ลพบุรี
  ["th-pa", 0, 0], // พระนครศรีอยุธยา
  ["th-np", 0, 0], // นครปฐม
  ["th-sb", 0, 0], // สิงห์บุรี
  ["th-cn", 0, 0], // ชัยนาท
  ["th-bm", 0, 0], // กรุงเทพมหานคร
  ["th-pt", 0, 0], // ปทุมธานี
  ["th-no", 0, 0], // นนทบุรี
  ["th-sp", 0, 0], // สมุทรปราการ
  ["th-ss", 0, 0], // สมุทรสาคร
  ["th-sm", 0, 0], // สมุทรสงคราม
  ["th-pe", 0, 0], // เพชรบุรี
  ["th-cc", 0, 0], // ฉะเชิงเทรา
  ["th-nn", 0, 0], // นครนายก
  ["th-cb", 0, 0], // ชลบุรี
  ["th-br", 0, 0], // บุรีรัมย์
  ["th-kk", 0, 0], // ขอนแก่น
  ["th-ph", 0, 0], // เพชรบูรณ์
  ["th-kl", 0, 0], // กาฬสินธุ์
  ["th-sr", 0, 0], // สระบุรีs
  ["th-nr", 0, 0], // นครราชสีมา
  ["th-si", 0, 0], // ศรีสะเกษ
  ["th-re", 0, 0], // ร้อยเอ็ด
  ["th-le", 0, 0], // เลย
  ["th-nk", 0, 0], // หนองคาย
  ["th-ac", 0, 0], // อำนาจเจริญ
  ["th-md", 0, 0], // มุกดาหาร
  ["th-sn", 0, 0], // สกลนคร
  ["th-nw", 0, 0], // นราธิวาส
  ["th-pi", 0, 0], // ปัตตานี
  ["th-rn", 0, 0], // ระนอง
  ["th-nt", 0, 0], // นครศรีธรรมราช
  ["th-sg", 0, 0], // สงขลา
  ["th-pr", 0, 0], // แพร่
  ["th-py", 0, 0], // พะเยา
  ["th-so", 0, 0], // สุโขทัย
  ["th-ud", 0, 0], // อุตรดิตถ์
  ["th-kn", 0, 0], // กาญจนบุรี
  ["th-tk", 0, 0], // ตาก
  ["th-ut", 0, 0], // อุทัยธานี
  ["th-ns", 0, 0], // นครสวรรค์
  ["th-pk", 0, 0], // ประจวบคีรีขันธ์
  ["th-ur", 0, 0], // อุบลราชธานี
  ["th-sk", 0, 0], // สระแก้ว
  ["th-ry", 0, 0], // ระยอง
  ["th-cy", 0, 0], // ชัยภูมิ
  ["th-su", 0, 0], // สุรินทร์
  ["th-nf", 0, 0], // นครพนม
  ["th-bk", 0, 0], // บึงกาฬ
  ["th-mh", 0, 0], // แม่ฮ่องสอน
  ["th-pu", 0, 0], // ภูเก็ต
  ["th-cp", 0, 0], // ชุมพร
  ["th-yl", 0, 0], // ยะลา
  ["th-cr", 0, 0], // เชียงราย
  ["th-cm", 0, 0], // เชียงใหม่
  ["th-ln", 0, 0], // ลำพูน
  ["th-na", 0, 0], // น่าน
  ["th-lg", 0, 0], // ลำปาง
  ["th-pb", 0, 0], // ปราจีนบุรี
  ["th-rt", 0, 0], // ราชบุรี
  ["th-ys", 0, 0], // ยโสธร
  ["th-ms", 0, 0], // มหาสารคาม
  ["th-un", 0, 0], // อุดรธานี
  ["th-nb", 0, 0], // หนองบัวลำภู
];

export default {
  name: "FollowUp",
  components: {
    Icon,
    Chart,
  },
  props: {
    filter: {
      type: Object,
      default: () => ({
        plan_id: "",
        region_id: "",
        year: "",
      }),
    },
    exportExcel: {
      type: Boolean,
      default: false,
    },
    region: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isGaugeChartOptions: true,
      gaugeChartOptions: {
        chart: {
          type: "gauge",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          width: 372,
          height: 372,
        },
        credits: {
          enabled: false,
        },

        title: {
          text: "",
        },

        pane: {
          startAngle: -90,
          endAngle: 90,
          background: null,
          //center: ['50%', '55%'],
          //size: '100%'
        },

        // the value axis
        yAxis: {
          min: 0,
          max: 100,
          tickPixelInterval: 100,
          tickPosition: "inside",
          tickColor: "#FFFFFF",
          tickLength: 30,
          tickWidth: 0,
          minorTickInterval: null,
          labels: {
            enabled: false,
            distance: 20,
            style: {
              fontSize: "14px",
            },
          },
          plotBands: [
            {
              from: 0,
              to: 59,
              color: "#E51610", // green
              thickness: 50,
            },
            {
              from: 59,
              to: 90,
              color: "#FBB040", // yellow
              thickness: 50,
            },
            {
              from: 90,
              to: 100,
              color: "#216957", // red
              thickness: 50,
            },
          ],
        },

        series: [
          {
            name: "ภาพรวมผลติดตาม",
            data: [75],
            tooltip: {
              valueSuffix: " ฿",
            },
            dataLabels: {
              enabled: false,
              format: "{y} ฿",
              borderWidth: 0,
              color: "#FFDD40",
              style: {
                fontSize: "16px",
              },
            },
            dial: {
              radius: "80%",
              backgroundColor: "#464647",
              baseWidth: 12,
              baseLength: "0%",
              rearLength: "0%",
            },
            pivot: {
              backgroundColor: "#464647",
              radius: 6,
            },
          },
        ],
      },

      mapSelected: true,
      mapOptions: {
        chart: {
          map: ThailandMapData,
          height: 580,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        mapNavigation: {
          enabled: false,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },

        colorAxis: {
          min: 1,
          minColor: "#F9BB43",
          maxColor: "#F15A29",
        },

        legend: {
          enabled: true,
          title: {
            text: "งบประมาณ",
          },
          backgroundColor: "rgba(255,255,255,0)",
          align: "left",
          verticalAlign: "bottom",
          /* y: 200, */
          /* floating: true, */
          borderWidth: 1,
        },
        plotOptions: {
          map: {
            borderColor: "#000",
            borderWidth: 0.5,
          },
        },
        tooltip: {
          shared: false,
          useHTML: true,
          shadow: false,
          backgroundColor: null,
          borderWidth: 0,
          formatter: function () {
            // console.log(this, this.y, this.key);
            return `
              <div class="tooltip" style="border-radius: 5px;padding: 0px">
                <div class="font-14 px-2 py-1 font-w-700" style="background-color: #464647; color: #fff">
                  ${this.point.value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ฿
                </div>
                <div class="pa-2 font-10 card_tooltip">
                   ${this.point.properties.name_th} (${
              this.point.totalProject
            } โครงการ)
                </div>
              </div>
              `;
          },
        },
        series: [
          {
            data: items,
            keys: ["hc-key", "value", "totalProject"],
            joinBy: "hc-key",
            name: "Random data",
            states: {
              hover: {
                color: "#464647",
              },
            },
            dataLabels: {
              enabled: true,
              format: "{point.properties.postal}",
            },
          },
        ],
      },
      mapRegionOptions: {
        chart: {
          map: ThailandMapData,
          height: 500,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        mapNavigation: {
          enabled: false,
          enableDoubleClickZoomTo: true,
          enableTouchZoom: true,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },

        colorAxis: {
          min: 1,
          minColor: "#F9BB43",
          maxColor: "#F15A29",
        },

        legend: {
          enabled: false,
          title: {
            text: "จังหวัดและจำนวนโครงการตามงบประมาณ",
          },
          backgroundColor: "rgba(255,255,255,0.85)",
        },
        plotOptions: {
          map: {
            allAreas: false,
            joinBy: ["hc-a2", "code"],
            mapData: ThailandMapData,
            borderColor: "#000",
            borderWidth: 0.5,
            dataLabels: {
              enabled: true,
              color: "#FFFFFF",
              style: {
                fontWeight: "bold",
              },
              // Only show dataLabels for areas with high label rank
              format: null,
              formatter: function () {
                if (
                  this.point.properties &&
                  this.point.properties.labelrank.toString() < 5
                ) {
                  return this.point.properties["hc-a2"];
                }
              },
            },
          },
        },
        tooltip: {
          shared: false,
          useHTML: true,
          shadow: false,
          backgroundColor: null,
          borderWidth: 0,
          formatter: function () {
            console.log(this, this.key, this.series);
            return `
              <div class="tooltip" style="border-radius: 5px;padding: 0px">
                <div class="font-14 px-2 py-1 font-w-700 font-ch" style="background-color: #464647; color: #fff">
                  ${this.series.userOptions.budget
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ฿
                </div>
                <div class="pa-2 font-10 card_tooltip  font-ch">
                   ${this.series.userOptions.name} (${
              this.series.userOptions.totalProject
            } โครงการ)
                </div>
              </div>
              `;
          },
        },

        series: [
          // ภาคเหนือ 17 จังหวัด
          {
            name: "ภาคเหนือ", // 17 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#F9BB43",
            // borderColor: "#F9BB43",
            states: {
              hover: {
                color: "#F9BB43",
              },
            },
            data: [
              "CR", // Chiang Rai
              "NA", // Nan
              "PY", // Phayao
              "CM", // Chiang Mai
              "MH", // Mae Hong Son
              "PR", // Phrae
              "LG", // Lampang
              "LN", // Lamphun
              "TK", // Tak
              "UD", // Uttaradit
              "PS", // Phitsanulok
              "SO", // Sukhothai
              "PH", // Phetchabun
              "PC", // Phichit
              "KP", // Kamphaeng Phet
              "NS", // Nakorn Sawan
              "UT", // Uthai Thani
            ].map((code) => ({ code })),
          },
          // ภาคตะวันออกเฉียงเหนือ 12 จังหวัด
          {
            name: "ภาคตะวันออกเฉียงเหนือ", // 12 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#EE8046",
            // borderColor: "#EE8046",
            states: {
              hover: {
                color: "#EE8046",
              },
            },
            data: [
              "UN", // Udon Thani
              "NB", // Nong Bua Lamphu
              "LE", // Loei
              "NK", // Nong Khai
              "KL", // Kalasin
              "KK", // Khon Kaen
              "BK", // Bueng Kan
              "SN", // Sakon Nakhon
              "MD", // Mukdahan
              "MS", // Maha Sarakham
              "RE", // Roi Et
              "NF", // Nakhon Phanom
              // "NF", // Nakhon Phanom
            ].map((code) => ({ code })),
          },
          // ภาคตะวันออกเฉียงเหนือตอนล่าง 8 จังหวัด
          {
            name: "ภาคตะวันออกเฉียงเหนือตอนล่าง", // 8 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#216957",
            // borderColor: "#216957",
            states: {
              hover: {
                color: "#216957",
              },
            },
            data: [
              "NR", // Nakhon Ratchasima
              "CY", // Chaiyaphum
              "BR", // Buriram
              "SI", // Si Sa Ket
              "SU", // Surin
              "YS", // Yasothon
              "UR", // Ubon Ratchathani
              "AC", // Amnat Charoen
            ].map((code) => ({ code })),
          },
          // ภาคใต้ 14 จังหวัด
          {
            name: "ภาคใต้", // 14 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#3B608A",
            // borderColor: "#3B608A",
            states: {
              hover: {
                color: "#3B608A",
              },
            },
            data: [
              "PG", // Phang Nga
              "ST", // Surat Thani
              "KR", // Krabi
              "SA", // Satun"PL"
              "TG", // Trang
              "PL", // Phatthalung
              "NW", // Narathiwat
              "PI", // Pattani
              "RN", // Ranong
              "NT", // Nakhon Si Thammarat
              "SG", // Songkhla
              "PU", // Phuket
              "CP", // Chumphon
              "YL", // Yala
            ].map((code) => ({ code })),
          },
          // ภาคกลาง 14 จังหวัด
          {
            name: "ภาคกลาง", // 14 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#41DFFF",
            // borderColor: "#41DFFF",
            states: {
              hover: {
                color: "#41DFFF",
              },
            },
            data: [
              "SH", // Suphan Buri
              "AT", // Ang Thong
              "LB", // Lop Buri
              "SR", // Saraburi
              "PA", // Phra Nakhon Si Ayutthaya
              "NP", // Nakhon Pathom
              "SB", // Sing Buri
              "CN", // Chai Nat
              "BM", // Bangkok Metropolis
              "PT", // Pathum Thani
              "NO", // Nonthaburi
              "SP", // Samut Prakan
              "SS", // Samut Sakhon
              "SM", // Samut Songkhram
            ].map((code) => ({ code })),
          },
          // ภาคตะวันออก 8 จังหวัด
          {
            name: "ภาคตะวันออก", // 8 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#C198C4",
            // borderColor: "#C198C4",
            states: {
              hover: {
                color: "#C198C4",
              },
            },
            data: [
              "CT", // Chanthaburi
              "TT", // Trat
              "CC", // Chachoengsao
              "NN", // Nakhon Nayok
              "CB", // Chon Buri
              "SK", // Sa Kaeo
              "RY", // Rayong
              "PB", // Prachin Buri
            ].map((code) => ({ code })),
          },
          // ภาคตะวันตก 4 จังหวัด
          {
            name: "ภาคตะวันตก", // 4 จังหวัด
            budget: 0,
            totalProject: 0,
            color: "#FF6161",
            // borderColor: "#FF6161",
            states: {
              hover: {
                color: "#FF6161",
              },
            },
            data: [
              "PE", // Phetchaburi
              "KN", // Kanchanaburi
              "PK", // Prachuap Khiri Khan
              "RT", // Ratchaburi
            ].map((code) => ({ code })),
          },
        ],
      },
      dialog: false,

      data: {
        allProgressRate: 75,
        plans: [
          {
            nameTH: "แผนงานพัฒนา",
            nameEN: "IRTC",
            rate: 0,
            code: "#F19782",
          },
          {
            nameTH: "แผนงาน Collaborative",
            nameEN: "Research",
            rate: 0,
            code: "#F9BB43",
          },
          {
            nameTH: "แผนงาน STI Business",
            nameEN: "Incubation",
            rate: 0,
            code: "#F7941D",
          },
          {
            nameTH: "แผนงาน Service",
            nameEN: "Platform",
            rate: 0,
            code: "#F15A29",
          },
        ],
        regions: [
          {
            name: "ภาคเหนือ",
            rate: 0,
            code: "#F9BB43",
          },
          {
            name: "ภาคตะวันออกเฉียงเหนือ",
            rate: 0,
            code: "#EE8046",
          },
          {
            name: "ภาคตะวันออกเฉียงเหนือตอนล่าง",
            rate: 0,
            code: "#216957",
          },
          {
            name: "ภาคใต้",
            rate: 0,
            code: "#3B608A",
          },
        ],
        budgetProjects: [
          // {
          //   id: 1,
          //   planMaster: "แผนงานพัฒนาขีดความสาม", // planMaster
          //   projectName: "โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์แห่งชาติ", // projectName
          //   university: "มหาวิทยาลัยเชียงใหม่", // universityName
          //   province: "เชียงใหม่", // province
          //   startDate: "2023-04-04",
          //   endDate: "2023-04-10",
          //   durationProgress: 30,
          //   durationBudget: 50,
          //   totalBudget: 1000000,
          // },
          // {
          //   id: 1,
          //   plan: "แผนงานพัฒนาขีดความสาม",
          //   name: "โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์แห่งชาติ",
          //   university: "มหาวิทยาลัยเชียงใหม่",
          //   province: "เชียงใหม่",
          //   startDate: "2023-04-04",
          //   endDate: "2023-04-10",
          //   durationProgress: 50,
          //   durationBudget: 90,
          //   totalBudget: 1000000,
          // },
        ],
      },
      paginate: {
        current_page: 1,
        last_page: 1,
        total: 1,
      },
    };
  },
  watch: {
    filter: {
      handler: function (val) {
        this.onFilter();
      },
      deep: true,
    },
    exportExcel: function (val) {
      if (val) {
        this.exportToExcel();
      }
    },
  },
  async created() {
    await Promise.all([
      this.getData(),
      this.getBudgetProject(),
      this.budgetMap(),
    ]);
    // await this.getData();
    // await this.getBudgetProject(1);
    // await this.budgetMap();
    const topologyTH = ThailandMapData;
    console.log(topologyTH);
    this.mapOptions.chart.map = topologyTH;
    this.mapOptions.series[0].mapData = topologyTH;
    this.mapRegionOptions.plotOptions.map.mapData = topologyTH;
  },
  methods: {
    async onFilter() {
      await Promise.all([
        this.getData(),
        this.getBudgetProject(),
        this.budgetMap(),
      ]);
    },
    async getData() {
      this.isGaugeChartOptions = false;
      let res = await this.$apiFire("Dashboard/progress", this.filter);
      if (res) {
        // console.log(res);
        // ภาพรวมผลติดตามสำหรับ Gauge Chart
        this.gaugeChartOptions.series[0].data[0] = res.allProgressRate;
        this.isGaugeChartOptions = true;

        // ร้อยละผลติดตาม
        this.data.plans = res.plans.map((plan) => {
          let code = "";
          if (plan.nameEN === "Service Platform") {
            code = "#F15A29";
          } else if (
            plan.nameEN ===
            "Industrial Research and Technology Capacity Development Program (IRTC)"
          ) {
            code = "#F19782";
          } else if (plan.nameEN === "STI Business Incubation") {
            code = "#F7941D";
          } else if (plan.nameEN === "Collaborative Research") {
            code = "#F9BB43";
          }

          return {
            ...plan,
            code: code,
          };
        });

        // ภาพรวมผลติดตาม
        this.data.allProgressRate = res.allProgressRate;

        // ภาพรวมผลติดตามแยกตามภูมิภาค progress rate
        res.regions.forEach((element) => {
          switch (element.name) {
            case "ภาคเหนือ":
              this.data.regions[0].rate = element.rate;
              break;
            case "ภาคตะวันออกเฉียงเหนือ":
              this.data.regions[1].rate = element.rate;
              break;
            case "ภาคตะวันออกเฉียงเหนือตอนล่าง":
              this.data.regions[2].rate = element.rate;
              break;
            case "ภาคใต้":
              this.data.regions[3].rate = element.rate;
              break;
            default:
              break;
          }
        });
      }
    },

    async getBudgetProject(page) {
      this.filter["page"] = page;
      let res = await this.$apiFire("Dashboard/budgetList", this.filter);
      if (res) {
        this.data.budgetProjects = res.data;
        this.paginate = {
          total: res.total,
          current_page: res.current_page,
          perPage: res.last_page,
        };
      }
    },

    onPageChange(page) {
      this.getBudgetProject(page);
    },

    async budgetMap() {
      let res = await this.$apiFire("Dashboard/budgetMap", this.filter);
      if (res) {
        console.log(res);
        this.mapOptions.series[0].data = res.provinces;

        this.mapRegionOptions.series.forEach((e) => {
          res.regions.forEach((region) => {
            if (e.name === region.name) {
              e.budget = region.budget;
              e.totalProject = region.totalProject;
            }
          });
        });

        console.log(" this.mapRegionOptions.series");
      }
    },
    no(index) {
      return (this.paginate.current_page - 1) * 10 + index;
    },
    dateThaiFormat(date) {
      let d = moment(date);
      return d.locale("th").add(543, "year").format("DD MMM YYYY");
    },
    showDialog() {
      this.dialog = true;
      // this.mapOptions.chart.width = 1000;
      // this.mapRegionOptions.chart.width = 1000;
    },
    closeDialog() {
      this.dialog = false;
      this.mapOptions.chart.width = 580;
      this.mapRegionOptions.chart.width = 500;
    },
    checkFormatNummber(number) {
      if (number == null) return 0;
      number = parseFloat(number).toFixed(1);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    exportToExcel() {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      // ส่วนหัวข้อ งบประมาณ
      let doc_date = moment().add(543, "year").format("DDMMYYYY");
      const topicRow = ["ผลติดตาม", "ข้อมูล ณ วันที่ " + doc_date];
      XLSX.utils.sheet_add_aoa(worksheet, [topicRow], { origin: "A1" });

      let jsonExcelSection1 = [];

      // ถ้าไม่ได้ filter ภูมิภาค ให้แสดงทภาพรวมผลติดตาม
      if (!this.filter.region_id) {
        // ทั้งหมด
        jsonExcelSection1.push({
          ลำดับ: 1,
          ชื่อแผนงาน: "ทั้งหมด",
          ร้อยละผลการดำเนินงาน: "",
          ภูมิภาค: "ทั้งหมด",
          จังหวัด: "ทั้งหมด",
          จำนวนโครงการที่ได้รับการสนับสนุน: "",
          ภาพรวมผลการดำเนินงาน: this.data.allProgressRate + " %",
          การใช้จ่ายงบประมาณรายโครงการ: "",
          ชื่อโครงการ: "",
          มหาวิทยาลัย: "",
          ระยะเวลาโครงการ: "",
        });
      } else {
        jsonExcelSection1.push({
          ลำดับ: 1,
          ชื่อแผนงาน: "ทั้งหมด",
          ร้อยละผลการดำเนินงาน: "",
          ภูมิภาค: this.region.find((e) => e.id == this.filter.region_id)?.name,
          จังหวัด: "ทั้งหมด",
          จำนวนโครงการที่ได้รับการสนับสนุน: "",
          ภาพรวมผลการดำเนินงาน: this.data.allProgressRate + " %",
          การใช้จ่ายงบประมาณรายโครงการ: "",
          ชื่อโครงการ: "",
          มหาวิทยาลัย: "",
          ระยะเวลาโครงการ: "",
        });
      }

      this.data.budgetProjects.forEach((budgetProject) => {
        let plan = this.data.plans.find(
          (plan) => plan.nameTH === budgetProject.planMaster
        );
        // init plan.projects = []
        plan.projects = plan.projects || [];
        if (plan) {
          plan.projects.push(budgetProject);
        }
      });

      // ชื่อแผนงาน
      this.data.plans.forEach((plans, i) => {
        jsonExcelSection1.push({
          ลำดับ: 2 + i,
          ชื่อแผนงาน: plans.nameTH,
          ร้อยละผลการดำเนินงาน: plans.rate + " %",
          ภูมิภาค: "",
          จังหวัด:
            plans.projects && plans.projects.length > 0
              ? plans.projects[0].province
              : "",
          จำนวนโครงการที่ได้รับการสนับสนุน: null,
          ภาพรวมผลการดำเนินงาน: null,
          การใช้จ่ายงบประมาณรายโครงการ:
            plans.projects && plans.projects.length > 0
              ? plans.projects[0].totalBudget
              : "",
          ชื่อโครงการ:
            plans.projects && plans.projects.length > 0
              ? plans.projects[0].projectName
              : "",
          มหาวิทยาลัย:
            plans.projects && plans.projects.length > 0
              ? plans.projects[0].university
              : "",
          ระยะเวลาโครงการ:
            plans.projects && plans.projects.length > 0
              ? plans.projects[0].projectStart +
                " - " +
                plans.projects[0].projectEnd
              : "",
        });

        plans.projects?.forEach((project, s) => {
          if (s != 0) {
            jsonExcelSection1.push({
              ลำดับ: "",
              ชื่อแผนงาน: "",
              ร้อยละผลการดำเนินงาน: "",
              ภูมิภาค: "",
              จังหวัด: project.province,
              จำนวนโครงการที่ได้รับการสนับสนุน: null,
              ภาพรวมผลการดำเนินงาน: "",
              การใช้จ่ายงบประมาณรายโครงการ: project.totalBudget,
              ชื่อโครงการ: project.projectName,
              มหาวิทยาลัย: project.university,
              ระยะเวลาโครงการ:
                project.projectStart + " - " + project.projectEnd,
            });
          }
        });
      });

      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection1, {
        origin: "A2",
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      let fileName = `Progress_dashboard_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      this.$emit("clearExportExcel", false);
    },
  },
};
</script>

<style lang="scss">
.follow_up {
  background-color: #f5f5f5;
  padding: 10px;
  .gauge_chart {
    .highcharts-container {
      margin-bottom: -11.5rem !important;
      margin-top: -1.5rem;
    }
  }
  .custom_card {
    border-radius: 20px;
    padding: 2rem;
  }
  .ellipsis-1-line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .custom_table {
    tr td {
      border: 0px !important;
    }
  }
  .custom_paginate {
    .v-pagination__item {
      border-radius: 10px;
      box-shadow: unset !important;
    }
    .v-pagination__navigation {
      border-radius: 10px;
      box-shadow: unset !important;
      background-color: transparent !important;
    }
  }
}
.btn_switch_map {
  background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
  border-radius: 25px;
  width: 75px;
  height: 30px;
  color: #fff;
  padding: 1px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  position: relative;
}
</style>
